import React from 'react';
import Button, { type CustomThemeButtonProps } from '@atlaskit/button/custom-theme-button';

// This is a workaround because React.memo does not play well with styled-components
// KIRBY-3030 TODO determine whether this workaround is still necessary after migration away from styled-components
export default function StyledComponentsButton(props: CustomThemeButtonProps) {
	return <Button {...props} />;
}
